module.exports = __webpack_public_path__ + "static/media/naira-logo128x128.ac8c7c55.png";